
import { FiChevronUp, FiChevronDown } from "react-icons/fi";
import { motion } from 'framer-motion';
import { PropTypes } from 'prop-types';


const Accordion = ({ accordion, setAccordion }) => {


    const toggleAccordion = index => {
        setAccordion(
            accordion?.map((faq, i) => {
                if (i === index) {
                    faq.open = !faq.open;
                } else {
                    faq.open = false;
                }

                return faq;
            })
        );
    };
    if(accordion == null){
        return null
    }
    return (
        <div className="w-full h-fit  bg-white rounded-2xl border-2 border-stone-300  py-8 flex flex-col gap-5" >
            {
                accordion?.map((faq, index) => (
                    <div key={index} className={`w-full flex flex-col   gap-2 p-6  ${index < accordion?.length - 1 && "border-b"}`}>
                        <div className="flex w- items-center h-full  justify-between cursor-pointer " onClick={() => toggleAccordion(index)}>
                            <motion.span
                                animate={
                                    {
                                        fontSize: faq.open ? "24px" : "18px",
                                        lineHeight: faq.open ? "32px" : "28px",
                                        color: faq.open ? "#0039CB" : "#040430"
                                    }
                                }
                                transition={{
                                    type: 'spring',
                                    stiffness: 300,
                                    damping: 20

                                }}
                                className="text-slate-900  text-2xl font-semibold cursor-pointer">{faq?.question}</motion.span>
                            <span className="text-slate-900 text-2xl font-bold" >{faq.open ? <FiChevronUp /> : <FiChevronDown />}</span>
                        </div>
                        <motion.div
                            initial={
                                {
                                    opacity: 0,
                                    height: 0
                                }
                            }
                            animate={faq.open ? { opacity: 1, height: "fit-content" } : { opacity: 0, height: 0 }}
                            transition={{
                                type: 'spring',
                                stiffness: 300,
                                damping: 20

                            }}
                            className={`flex flex-col w-full gap-2 accordion  ${faq.open ? "z-[1]  ":" !hidden  z-[-1]"}`}>
                            {faq.answer}
                        </motion.div>
                    </div>
                ))
            }
        </div>
    )
}
Accordion.propTypes = {
    accordion: PropTypes.array,
    setAccordion: PropTypes.func,
}
export default Accordion